import { render, staticRenderFns } from "./MainGlobeScene.vue?vue&type=template&id=8b583800&scoped=true&"
import script from "./MainGlobeScene.vue?vue&type=script&lang=js&"
export * from "./MainGlobeScene.vue?vue&type=script&lang=js&"
import style0 from "./MainGlobeScene.vue?vue&type=style&index=0&id=8b583800&prod&scoped=true&lang=css&"
import style1 from "./MainGlobeScene.vue?vue&type=style&index=1&id=8b583800&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b583800",
  null
  
)

export default component.exports